import { InstrumentoFinanceiro, InstrumentoFinanceiroApiResponse, InstrumentoResumo } from "common/genericTypes";
import { formatCurrencyNumber, formatEightDecimalsCurrency } from "./number";
import moment from 'moment';

export function isDivisible(tipoInstrumento: InstrumentoFinanceiro | null): boolean {
    return tipoInstrumento === InstrumentoFinanceiro.CotasDeFundo;
}

export function getQuantityType(tipoInstrumento?: InstrumentoFinanceiro) {
    return tipoInstrumento && isDivisible(tipoInstrumento) ? 'eightDecimals' : 'integer';
}

export function formatInstrumentoCurrency(value?: number, tipoInstrumento?: InstrumentoFinanceiro) {
    return value && tipoInstrumento && isDivisible(tipoInstrumento) ? formatEightDecimalsCurrency(value)
                                                                    : formatCurrencyNumber(value);
}

export function getDataEmissaoDisplay(option: InstrumentoFinanceiroApiResponse): string {
    if (!option.criteriosRemuneracao?.dataEmissao) {
        return 'Data não informada';
    }
    return moment(option.criteriosRemuneracao.dataEmissao).format('DD/MM/YYYY');
}

export function getVolumeEmissaoDisplay(option: InstrumentoFinanceiroApiResponse): string {
    if (!option.criteriosRemuneracao?.volumeEmissao) {
        return 'Valor não informado';
    }
    return formatInstrumentoCurrency(
        option.criteriosRemuneracao.volumeEmissao,
        option.tipoInstrumentoFinanceiro
    );
}

export function getSafeDataEmissao(instrumento: InstrumentoFinanceiroApiResponse): Date {
    return instrumento.criteriosRemuneracao?.dataEmissao
        ? moment(instrumento.criteriosRemuneracao.dataEmissao).toDate()
        : new Date(0);
}


export function deveExibirAvisoConfirmacaoAgenteFiduciario(
    valorUnitarioPagamento?: number,
    instrumento?: InstrumentoResumo
): boolean {
    return !!valorUnitarioPagamento && instrumento?.regimeFiduciario === true;
}
